import React from 'react';
import Section from 'views/landing/Section';
import SectionContents from 'views/landing/SectionContents';
import SectionContentsHero from 'views/landing/SectionContentsHero';
import styles from './Hero.module.scss';
import HeroStats from './HeroStats';
import HeroSearch from './HeroSearch';

function Index() {
  return (
    <Section className={styles['hero-section']}>
      <link
        rel="preload"
        as="image"
        href="https://img.iafcertsearch.org/r/p/landing/homepage-hero-bg.png"
        fetchpriority="high"
      />
      <SectionContents sizes={{xs: [12, 12]}}>
        <div className={styles['hero-section--contents']}>
          <div className={styles['hero-section--contents--hero']}>
            <SectionContentsHero
              heading={
                <>
                  <span className={styles['hero-section--contents--tertiary']}>
                    Search
                  </span>{' '}
                  and{' '}
                  <span className={styles['hero-section--contents--tertiary']}>
                    Verify <br /> ISO Certification
                  </span>{' '}
                  & More
                </>
              }
              subHeading={
                <p>
                  The official global database for accredited certificates.
                  Check ISO certification online or verify other international,
                  national, and sector standard certificates with instant
                  alerts.
                </p>
              }
            />
          </div>
          <HeroSearch />
          <HeroStats />
        </div>
      </SectionContents>
    </Section>
  );
}

export default Index;
